/** WCAG 1.4.10 Reflow — CSS px width where 2D scrolling must not be required. */
export const REFLOW_VIEWPORT_MAX_WIDTH_PX = 320;

const DEFAULT_PAD_PX = 8;

export function shouldCenterPopupForReflow(
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : Infinity
): boolean {
  return viewportWidth <= REFLOW_VIEWPORT_MAX_WIDTH_PX;
}

export function centerPopupInViewport(
  popupWidth: number,
  popupHeight: number,
  viewportWidth = window.innerWidth,
  viewportHeight = window.innerHeight,
  pad = DEFAULT_PAD_PX
): { left: number; top: number } {
  let left = (viewportWidth - popupWidth) / 2;
  let top = (viewportHeight - popupHeight) / 2;
  left = Math.max(pad, Math.min(viewportWidth - popupWidth - pad, left));
  top = Math.max(pad, Math.min(viewportHeight - popupHeight - pad, top));
  return { left, top };
}

/** Clamp fixed `left` so the popup stays inside the viewport (after optional offset). */
export function clampPopupLeftToViewport(
  left: number,
  popupWidth: number,
  offsetLeft = 0,
  viewportWidth = window.innerWidth,
  pad = DEFAULT_PAD_PX
): number {
  const finalLeft = left + offsetLeft;
  const clampedFinal = Math.max(
    pad,
    Math.min(viewportWidth - popupWidth - pad, finalLeft)
  );
  return clampedFinal - offsetLeft;
}
